import {useEffect, useState} from "react";
import {PREVIEW_DOC_TYPES} from "../../../util/Constants";
import {Button, Modal, Spin} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import PreviewModalComp from "./PreviewModalComp";
import {ModalPropDto} from "../../../dto/ModalPropDto";


interface CommonModalCompProps {
    modalProp: ModalPropDto
}

const CommonModalComp = (props: CommonModalCompProps) => {
    const [modalProp, setModalProp] = useState<ModalPropDto>({docURL: "", isModalOpen: false, title: ""});
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>();


    const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {
        if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
            return PREVIEW_DOC_TYPES.IMAGE;
        } else {
            return PREVIEW_DOC_TYPES.PDF;
        }

    };

    useEffect(() => {
        console.log(props.modalProp)
        if (props.modalProp.docURL) {
            setModalProp(props.modalProp)
            setDocType(checkDocumentContentType(props.modalProp.docURL))
        }
    }, [props.modalProp.docURL])

    const closeModal = () => {
        setModalProp({...modalProp, isModalOpen: false})
    }

    const download = () => {
        let a = document.createElement('a');
        a.href = modalProp.docURL;
        a.download = undefined != modalProp.title ? modalProp.title : "Document";
        a.click();
    }

    return (
        <div>
            {props.modalProp.docURL ? <Modal
                    className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : ""}
                    open={modalProp.isModalOpen}
                    title={modalProp.title}
                    onCancel={closeModal}
                    destroyOnClose={true}
                    width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                    footer={[
                        <Button type="primary" icon={<DownloadOutlined/>}
                                style={{background: '#FF7400', height: 40}} onClick={download}>
                            Download
                        </Button>]}
                >
                    <PreviewModalComp docURL={modalProp.docURL} divHeight={'70vh'}/>
                </Modal>
                :
                <div className="loader-container">
                    <Spin size="large" tip="Loading"></Spin>
                </div>
            }
        </div>
    )

}
export default CommonModalComp;



